export enum ActorType {
    ApplicationUser,
    AdminUser,
    ShopUser,
    System,
}
